import { InjectionToken } from '@angular/core';

/**
 * @description
 * Provide max image size and max model 3d size in bytes
 *
 */
export const Model3dSizeLimitsToken = new InjectionToken<{
  thumbnailMaxSize: number;
  fileMaxSize: number;
}>('Model 3D limits configuration');
